import {Component} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {SessionEvents} from "../../orchestration/session-events";

@Component({
    selector: "woa-order-heading-panel",
    templateUrl: "order-heading-panel.component.html"
})

export class OrderHeadingPanelComponent {
    SessionEvents = SessionEvents;

    constructor(public orderingContextModel: OrderingContextModel,
                private navigationService: NavigationService) {
    }

    async editNotes(): Promise<void> {
        return this.navigationService.createPage("woa-customer-notes-edit-page");
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-page/order-heading-panel/order-heading-panel.component.ts